import FinancialsForm from './FinancialsForm';

export default FinancialsForm;
